import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel,
  AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

export function DeleteConfirmDialog({ item, onClose, onConfirm, titlePrefix = 'Supprimér', entityLabel = '' }) {
  const label = entityLabel || item?.title || '';
  return (
    <AlertDialog open={!!item} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{titlePrefix} ?</AlertDialogTitle>
          <AlertDialogDescription>
            Etes-vous sur de vouloir supprimér {label ? `« ${label} »` : 'cet element'} ?
            Cette action est irreversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="h-12">Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={() => onConfirm(item?.id)}
            className="h-12 bg-red-600 hover:bg-red-700" data-testid="confirm-delete-btn">
            Supprimér
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
